<template>
  <div class="show-error">
    <h3>Упс!!!Ошибка получения данных с сервера!!!</h3>
    <h4>Данные загружены из локального файла PseudoServer.</h4>
  </div>
</template>

<script>
export default {
  name: "show-error",
}
</script>
